window.FD = {}

window.FD.BlobToDataURL = function(blob) {
	return new Promise(function(resolve, reject) {
		if (!blob) {
			reject("null blob");
			return;
		}
		var fr = new FileReader();
		fr.onload = function(evt) {
			resolve(evt.target.result);
		}
		fr.readAsDataURL(blob);
	});
}
